import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/** Raiz da aplicação: delega layout e páginas ao router. */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
